import { configureStore, type Store, type ThunkDispatch, type UnknownAction } from '@reduxjs/toolkit';
import { createReduxEnhancer } from '@sentry/react';
import { isProduction } from 'utils/platform';

import rootReducer, { type RootState } from './rootReducer';

const sentryReduxEnhancer = createReduxEnhancer({
  attachReduxState: false,
});

type AppThunkDispatch = ThunkDispatch<RootState, any, UnknownAction>;
type AppStore = Omit<Store<RootState, UnknownAction>, 'dispatch'> & {
  dispatch: AppThunkDispatch;
};

const store: AppStore = configureStore({
  devTools: !isProduction(),
  reducer: rootReducer,
  enhancers: (getDefaultEnhancers) => {
    return getDefaultEnhancers().concat(sentryReduxEnhancer);
  },
});

export default store;

export type AppDispatch = typeof store.dispatch;

export interface IThunkApi {
  dispatch: AppDispatch;
  state: RootState;
}
